<div class="container">
  <div class="load-container">
    <div class="loader"></div>
    <div class="load-child">
      <img src="../../../assets/icons/fogo-e-peixe.png" sizes="25" />
    </div>
  </div>
</div>
